import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../../components/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { systemService } from '../../services/system.service';
import { getErrorMsg } from '../../utils/error';

const Maintenance = () => {
  const { t } = useTranslation('common');
  const [maintenance, setMaintenance] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  const refresh = async () => {
    setLoading(true);
    setError('');
    try {
      const status = await systemService.getStatus();
      setMaintenance(!!status.maintenance);
    } catch (e) {
      setError(getErrorMsg(e, 'Failed to load system status'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const toggle = async () => {
    setError('');
    try {
      const res = await systemService.setMaintenance(!maintenance);
      setMaintenance(!!res.maintenance);
    } catch (e) {
      setError(getErrorMsg(e, 'Failed to update maintenance'));
    }
  };

  return (
    <Layout title={t('maintenance')}>
      <div className="space-y-4">
        {error && (
          <div className="p-3 rounded-md bg-red-50 text-red-600 border border-red-100">
            {error}
          </div>
        )}
        <Card className="p-4 space-y-3">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-gray-600 dark:text-gray-300">Maintenance mode</div>
              <div className="text-lg font-semibold">{loading ? t('loading') : maintenance ? 'Enabled' : 'Disabled'}</div>
            </div>
            <Button variant="primary" onClick={toggle} disabled={loading}>
              Toggle
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default Maintenance;

